import React, { useContext, useEffect } from 'react';
import AuthRoutes from './AuthRoutes';
import { AuthContext } from '../contexts/AuthContext';
import AppRoutes from './AppRoutes';

const Router = () => {
  const { userToken } = useContext(AuthContext);

  // AGREGAR ESTE LOG
  useEffect(() => {
    console.log('🚦 Router - montado/re-montado, userToken:', userToken);
    return () => {
      console.log('🚦 Router - desmontado');
    };
  }, []);

  return <>{userToken ? <AppRoutes /> : <AuthRoutes />}</>;
};

export default Router;
